import React, { useMemo } from 'react';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetBoardInit } from 'api/queries/getBoardInit.query';
import { useQueryGetProjectVersionsList } from 'api/queries/getProjectVersionsList.query';
import { useQueryGetSingleWbs } from 'api/queries/getWbs.query';

import { buildRowsBoardFilter } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/RowsBoard/RowsBoardColumns.utils';
import { PinboardWidgetPills } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetPills/PinboardWidgetPills';

export const WidgetFiltersCell = ({ value }) => {
    const parsedValue = useMemo(() => {
        return JSON.parse(value);
    }, [value]);
    const { project, contract } = useProjectTreeStore();
    const projectId = project?.id;
    const contractId = contract?.id;
    const { data: versionsList } = useQueryGetProjectVersionsList({
        projectId,
        contractId,
    });

    const latestVersionId = versionsList?.[0]?.id;

    const { data: boardInit } = useQueryGetBoardInit({
        metaDataId: latestVersionId,
    });

    const { data: singleWbs } = useQueryGetSingleWbs({
        latestVersion: latestVersionId,
        taskId: parsedValue.filter.filters.find((item) => item.name === 'WBS_SEARCH')?.data[0],
    });

    const widgetFiltersData = buildRowsBoardFilter({
        filter: { filters: JSON.parse(value) },
        activityCodes: boardInit ? boardInit.activityCode : [],
        activityFragnet: boardInit ? boardInit.fragnetMilestone : [],
        assigneeOptionsList: boardInit ? boardInit.assignee : [],
        singleWbs: singleWbs || [],
    });

    return <PinboardWidgetPills filters={widgetFiltersData} />;
};
